var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 11 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.875 3V8.5L5.575 10.5M0.875 3L5.575 5M0.875 3L5.575 1.5L9.875 3M9.875 3V8.5L5.575 10.5M9.875 3L5.575 5M5.575 10.5V5","stroke":_vm.color,"stroke-width":"1.2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }